<template>
  <div :class="['error-cnt', {'gop-cnt' : isGopRoute}]">
    <h1 class="error-text-404">404</h1>
    <h2 class="error-text">{{ $t('errorPage.pageNotFound')}}</h2>
    <span class="subtext">{{ $t('errorPage.message')}}</span>
    <div class="button-group">
      <div class="project-report-button-cnt" @click="handleContactButton">
        <img src="@/drc/assets/icons/report-problem2.svg" alt="warning-sign"/>
        <h4>{{ $t('errorPage.reportAProblem')}}</h4>
      </div>
      <router-link tag="button" class="btn-filled" :to="`${isGopRoute ? '/gop/home' : '/home'}`">
				{{ $t('errorPage.toHomePage')}}
			</router-link>
    </div>
		<ReportAProblem
			v-if="showSendReportDialog"
			@closeDialog="showSendReportDialog = false"
			@handleMessage="sendEmailForProblem"
			:title="`${ $t('projectPage.what')}`"
			:sending="sending"
		/>
  </div>
</template>
<script>
  import ReportAProblem from "@/drc/components/ReportAProblem.vue";
	import {sendEmail, uploadEmailAttachment} from "@/common/services/common-request-service";
	import {NOTIFICATION_TYPE} from "@/common/utils/constants";
	import * as STATISTIC_SERVICE from "@/common/services/statistic-service";

	export default {
		components: {ReportAProblem},
		data() {
			return {
				previousRoute: null,
				showSendReportDialog: false,
				sending: false,
			}
		},
		computed: {
			isGopRoute() {
				return (this.previousRoute && this.previousRoute.path.includes('/gop/')) || this.$route.path.includes('/gop/');
			},
		},
    methods: {
      handleContactButton() {
				if(this.isGopRoute){
					window.open('mailto:akkodis.cmt@drc-akkodis.com?bcc=Desislava.ALEKSANDROVA@akkodis.com;Plamen.VELICHKOV@akkodis.com;Pavlina.VENKOVA@akkodis.com;');
				}else{
					this.showSendReportDialog = true;
				}

      },
			sendEmailForProblem(message) {
				const vue = this;
				this.sending = true;
				this.$store.dispatch('showLoading');

				if(message.image?.value?.get?.('file')){
					const newFormData = new FormData();
					newFormData.append('file', message.image.value.get('file'));
					uploadEmailAttachment(newFormData).then((response) => {
						const uploadedFileUrl = response.data.url
						this.sendEmail(uploadedFileUrl, message);
						vue.sending = false;
					})
						.catch((error) => {
							console.error(error);
							vue.sending = false;
						});
				}else{
					this.sendEmail(null, message);
				}
			},
			sendEmail(uploadedFileUrl, message){
				const vue = this;
				const body = {
					from: vue.$store.getters.getUser.email,
					title: `DRC - reported problem`,
					isDRC: true,
					to: {
						emails: ['vasil.ayvazov@akkodis.com', "petar.stoyanov@akkodis.com", "desislava.aleksandrova@akkodis.com", "plamen.velichkov@akkodis.com", "sabiha.mangova@akkodis.com", "pavlina.venkova@akkodis.com"]
					},
					message: `Reported problem: <br><br>
								<div style="margin: 10px;">Problem page name: 404 Page</div>
								<div style="margin: 10px;">Problem page: ${vue.$route.path}</div>
								<div style="margin: 10px;">Problem topic: ${message.topic.value?.[0]?.name || 'Other'}</div>
								<div style="margin: 10px;">Problem description: ${message.description.value}</div>`
				}
				if(uploadedFileUrl){
					body.message += `<img src="${uploadedFileUrl}" alt="image"/>`
				}

				sendEmail(body).then(() => {
					vue.showNotification(`${vue.$t(`notifications.successfullyReportedProblem`)}`, NOTIFICATION_TYPE.SUCCESS);
					const props = {
						action: STATISTIC_SERVICE.ACTIONS.COMMON.REPORT_PROBLEM,
						comment: JSON.stringify({current_route: `${window.location.href}`})
					}
					STATISTIC_SERVICE.addDrcStatistic(props)
				})
					.catch((error) => {
						console.error(error);
					})
					.finally(() => {
						vue.$store.dispatch('hideLoading');
						vue.sending = false;
						vue.showSendReportDialog = false;
					})
			},
    },
		beforeRouteEnter(to, from, next) {
			next(vm => {
				vm.previousRoute = from;
			});
		},
  }
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.error-cnt {
  width: 90%;
  margin: auto;
  height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.error-text-404 {
  font-size: 200px;
  color: #FDB71A;
  margin: 250px 0 0 0;

  @media (max-width: 425px) {
    font-size: 140px;
  }
}

.error-text {
  font-weight: 800;
  font-size: 55px;
  line-height: 70px;
  color: #FFFFFF;
  margin-top: 60px;
  margin-bottom: 25px;
}

.subtext {
  display: block;
  font-size: 18px;
  line-height: 21px;
  color: #FFFFFF;

  @media (max-width: 425px) {
    text-align: center;
  }
}

.button-group {
  margin-top: 100px;
  display: flex;
  gap: 40px;

  @media (max-width: 425px) {
    gap: 0
  }

  .project-report-button-cnt  {
    display: flex;
    align-items: center;
    cursor: pointer;
    min-width: 170px;
    margin-left: 40px;

    img {
      height: 24px;
      margin-right: 10px;
			margin-top: -4px;
    }

    h4 {
      font-size: 16px;
      font-weight: 500;
      margin: 0;

      @media (max-width: 425px) {
        font-size: 14px;
      }

      &:hover {
        color: $color-secondary-light;
      }
    }

    @media (max-width: $tablet){
      margin-left: 0;
    }
  }

  .btn-filled {
    padding: 15px 18px;
    background: $color-secondary-light;
    border: none;
    border-radius: 4px;
    outline: none;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.01em;
    color: $color-primary-light;
    cursor: pointer;

    @media (max-width: 425px) {
      font-size: 14px;
    }
  }
}

.gop-cnt {
	.error-text-404 {
		color: $color-grey;
	}

	.subtext {
		color: $color-grey
	}

	.button-group {
		.project-report-button-cnt > h4:hover {
			color: $color-grey
		}

		.btn-filled {
			background: $gop-blue;
		}
	}
}
</style>
